import { useState } from "react";

export const useReportFilters = () => {
    const [filterAll, setFilterAll] = useState('this_month');
    const [filterSingle, setFilterSingle] = useState('this_month');
    const [filterAllDateFrom, setFilterAllDateFrom] = useState("");
    const [filterAllDateTo, setFilterAllDateTo] = useState("");
    const [filterSingleDateFrom, setFilterSingleDateFrom] = useState("");
    const [filterSingleDateTo, setFilterSingleDateTo] = useState("");
    const [currentUserId, setCurrentUserId] = useState(null);

    const clearAllDates = () => {
        setFilterAllDateFrom('');
        setFilterAllDateTo('');
        setFilterAll('this_month');
    }
    const clearSingleDates = () =>{
        setFilterSingleDateFrom('');
        setFilterSingleDateTo('');
        setFilterSingle('this_month');
    };
    return {
        filterAll, setFilterAll,
        filterSingle, setFilterSingle,
        filterAllDateFrom, setFilterAllDateFrom,
        filterAllDateTo, setFilterAllDateTo,
        filterSingleDateFrom, setFilterSingleDateFrom,
        filterSingleDateTo, setFilterSingleDateTo,
        currentUserId, setCurrentUserId,
        clearAllDates,
        clearSingleDates
    };
};